import { defineAsyncComponent } from 'vue'

import { defineNuxtPlugin } from 'nuxt/app'

import { registerAccountSettingsTabComponent } from '@layers/account-settings/common-layer/utils/account-settings-tab-registry'

export const ACCOUNT_EVENTS_TAB_COMPONENT_NAME = 'Events'

/**
 * Registers the Events organism with the shared account-settings shell. Living in this layer's
 * plugin (instead of an import in common-layer) is what keeps GoKollab, Meet and Courses — which do
 * not compose this layer — from resolving its ClientPortal-only module graph at build time. The
 * async boundary keeps the SDUI runtime out of ClientPortal's eager graph too. The same organism is
 * used on web and mobile (SDUI Type 2, not a Vue-only mobile fork).
 */
export function registerAccountEventsTab(): void {
  const Events = defineAsyncComponent(() => import('../components/organisms/Events.vue'))
  registerAccountSettingsTabComponent(ACCOUNT_EVENTS_TAB_COMPONENT_NAME, { web: Events, mobile: Events })
}

export default defineNuxtPlugin({
  name: 'account-settings-events-tab',
  setup() {
    registerAccountEventsTab()
  },
})
